
import { trackBreadcrumbClick } from "@/utils/track"
export default {
  name: "Breadcrumb",
  components: {},
  props: {
    configs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      configData: []
    }
  },
  computed: {},
  watch: {
    configs: {
      handler(newVal) {
        if (newVal && newVal.length) {
          newVal.forEach(e => {
            if (e.path == "") {
              e.path = "/"
            }
          })
        }
        this.configData = newVal
      },
      immediate: true,
      deep: true
    }
  },

  methods: {
    // breadcrumbClick(item, index, configs) {
    //   if (index + 1 < this.configData.length) {
    //     this.$emit("breadcrumbClick", item, index, configs)
    //   }
    // }
    breadcrumbClick(item) {
      return item.params ? `${this.MAIN_PATH}/category/${item.params.split(",").join("-")}/1.html` : `${this.MAIN_PATH}`
    },
    handleClickBreadcrumb(index) {
      this.trackBreadcrumbClick(index)
    },
    trackBreadcrumbClick(index) {
      const breadcrumb = this.configData.slice(0, index + 1)
      const breadcrumbName = breadcrumb.map(item => item.name).join(">")
      trackBreadcrumbClick(breadcrumbName)
    }
  }
}
